import Anchor from "components/BaseWidgets/anchor";
import AboutPanel from "components/PersonProfile/components/AboutPanel";
import InterestsPanel from "components/PersonProfile/components/InterestsPanel";
import ContactPanel from "components/PersonProfile/components/ContactPanel";
import CareerPanel from "components/PersonProfile/components/CareerPanel";
import PhysicalAppearancePanel from "components/PersonProfile/components/PhysicalAppearancePanel";
import FamilyPanel from "components/PersonProfile/components/FamilyPanel";
import { useEffect, useState } from "react";
import { anchorItems } from "./helper";
import "./style.scss";
import { usePremium } from "context/PremiumContext";
import PartnerPreferences from "./components/PartnerPreferences";
import Header from "./components/Header";
import { useLocation } from "react-router-dom";
import { useMyProfile } from "hooks/api/useProfile";
import ManagePhotos from "components/ManagePhotos";

function MyProfile() {
  const { isPremium } = usePremium();
  const [scrolled, setScrolled] = useState(false);
  const [managePhotoView, setManagedPhoto] = useState(false);

  const location = useLocation();
  const SCROLL_OFFSET_LOCATION = 135;
  const SCROLL_OFFSET = 105;

  const { data: profileData, isLoading: profileLoading } = useMyProfile();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 250;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) {
        setTimeout(() => {
          const offset =
            id === "current-address" || id === "permanent-address"
              ? SCROLL_OFFSET_LOCATION
              : SCROLL_OFFSET;

          const y =
            element.getBoundingClientRect().top + window.scrollY - offset;

          window.scrollTo({ top: y, behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="person-profile-frame container profile-page">
      {managePhotoView ? (
        <ManagePhotos
          managePhotoView={managePhotoView}
          user={profileData}
          setManagedPhoto={setManagedPhoto}
        />
      ) : (
        <>
          {" "}
          <Header
            setManagedPhoto={setManagedPhoto}
            isPremium={isPremium}
            user={profileData?.user}
            isLoading={profileLoading}
          />
          <div className={`sticky-anchor ${scrolled ? "scrolled" : ""}`}>
            <Anchor
              className={`person-profile-anchor`}
              items={anchorItems}
              targetOffset={150}
            />
          </div>
          <div className="content-frame flex flex-col gap-5 mb-16">
            <AboutPanel
              isEdit
              id="about-me"
              hasPremium={isPremium}
              profile={profileData}
            />
            <InterestsPanel
              isEdit
              id="interests-personality"
              interests={profileData?.interests || []}
              personality={profileData?.personality || []}
            />
            <ContactPanel
              isEdit
              id="contact"
              hasPremium={isPremium}
              contactDetails={profileData}
            />
            <CareerPanel isEdit id="career" careerDetails={profileData} />
            <PhysicalAppearancePanel
              isEdit
              id="physical"
              hasPremium={isPremium}
              physicalDetails={profileData}
            />
            <FamilyPanel isEdit id="family" familyDetails={profileData} />
            <PartnerPreferences
              isEdit
              id="partner-preferences"
              partnerPreference={profileData?.partner_preference}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default MyProfile;
